
import React from "react";
import TrialsList from "./TrialsList";
import TrialsHeader from "./TrialsHeader";
import { useTrials } from "./useTrials";

const TrialsModule: React.FC = () => {
  const {
    trials,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
    refresh,
  } = useTrials();

  return (
    <div className="space-y-6">
      <TrialsHeader 
        searchQuery={searchQuery} 
        setSearchQuery={setSearchQuery} 
        refresh={refresh} 
      />
      
      {error ? (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-md p-4">
          Erro ao carregar test drives: {error}
        </div>
      ) : (
        <TrialsList trials={trials} isLoading={isLoading} />
      )}
    </div>
  );
};

export default TrialsModule;
